module.exports = __webpack_public_path__ + "media/images/icons/incomplete-achievement-40673700596288f8f3522acce6531023.svg";